var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Pattern")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Regular expression pattern",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.regex.pattern,
            callback: function ($$v) {
              _vm.$set(_vm.clone.regex, "pattern", $$v)
            },
            expression: "clone.regex.pattern",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v("Enter the regular expression pattern to match"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Flags")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder:
              "Regular expression flags (e.g. 'g' for global, 'i' for case insensitive)",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.regex.flags,
            callback: function ($$v) {
              _vm.$set(_vm.clone.regex, "flags", $$v)
            },
            expression: "clone.regex.flags",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            "Optional regex flags: g (global), i (case insensitive), m (multiline), etc."
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Replacement Text"),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Replacement text (only for regex replace operations)",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.regex.replace,
            callback: function ($$v) {
              _vm.$set(_vm.clone.regex, "replace", $$v)
            },
            expression: "clone.regex.replace",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            "Replace matched text with this value (leave empty to just extract matches)"
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Match All Occurrences"),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.regex.matchAll,
            callback: function ($$v) {
              _vm.$set(_vm.clone.regex, "matchAll", $$v)
            },
            expression: "clone.regex.matchAll",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            "When enabled, returns all matches as an array instead of just the first match"
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }